import { render, staticRenderFns } from "./MonthlyBilling.vue?vue&type=template&id=677b5d42"
import script from "./MonthlyBilling.vue?vue&type=script&lang=js"
export * from "./MonthlyBilling.vue?vue&type=script&lang=js"
import style0 from "./MonthlyBilling.vue?vue&type=style&index=0&id=677b5d42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports